import React from 'react'
import { withIcon } from '../../withIcon'

function CaretDownIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M18.5793 9.34781H5.42024C5.25505 9.34781 5.10438 9.43571 5.03629 9.57154C4.96933 9.70638 4.99611 9.86518 5.10772 9.97605L11.6872 16.5331C11.8457 16.6919 12.1538 16.6919 12.3134 16.5331L18.8918 9.97605C19.0034 9.86518 19.0313 9.70638 18.9632 9.57154C18.8962 9.43571 18.7456 9.34781 18.5793 9.34781Z" fill={color}/>
    </svg>
  )
}

export default withIcon(CaretDownIcon)
